import { render, staticRenderFns } from "./KeywordsList.vue?vue&type=template&id=67bdaef0&scoped=true&"
import script from "./KeywordsList.vue?vue&type=script&lang=ts&"
export * from "./KeywordsList.vue?vue&type=script&lang=ts&"
import style0 from "./KeywordsList.vue?vue&type=style&index=0&id=67bdaef0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bdaef0",
  null
  
)

export default component.exports